// =============================================================================
// constants/kpiConstants.js
// Action types e constantes do módulo KPI
// =============================================================================

// --- Sites com coordenadas (mapa) ---
export const SITES_FETCH_REQUEST = 'SITES_FETCH_REQUEST';
export const SITES_FETCH_SUCCESS = 'SITES_FETCH_SUCCESS';
export const SITES_FETCH_FAILURE = 'SITES_FETCH_FAILURE';

// --- Incidents ---
export const INCIDENTS_FETCH_REQUEST = 'INCIDENTS_FETCH_REQUEST';
export const INCIDENTS_FETCH_SUCCESS = 'INCIDENTS_FETCH_SUCCESS';
export const INCIDENTS_FETCH_FAILURE = 'INCIDENTS_FETCH_FAILURE';

export const INCIDENT_HISTORY_FETCH_REQUEST = 'INCIDENT_HISTORY_FETCH_REQUEST';
export const INCIDENT_HISTORY_FETCH_SUCCESS = 'INCIDENT_HISTORY_FETCH_SUCCESS';
export const INCIDENT_HISTORY_FETCH_FAILURE = 'INCIDENT_HISTORY_FETCH_FAILURE';

export const INCIDENT_SELECT        = 'INCIDENT_SELECT';
export const INCIDENT_FILTER_CHANGE = 'INCIDENT_FILTER_CHANGE';
export const INCIDENT_FILTER_RESET  = 'INCIDENT_FILTER_RESET';

// --- Lookups (vendors, techs, kpis, severities, statuses da BD) ---
export const LOOKUPS_FETCH_REQUEST = 'LOOKUPS_FETCH_REQUEST';
export const LOOKUPS_FETCH_SUCCESS = 'LOOKUPS_FETCH_SUCCESS';
export const LOOKUPS_FETCH_FAILURE = 'LOOKUPS_FETCH_FAILURE';

// --- KPI Rules ---
export const RULES_FETCH_REQUEST = 'RULES_FETCH_REQUEST';
export const RULES_FETCH_SUCCESS = 'RULES_FETCH_SUCCESS';
export const RULES_FETCH_FAILURE = 'RULES_FETCH_FAILURE';

export const RULE_SAVE_REQUEST = 'RULE_SAVE_REQUEST';
export const RULE_SAVE_SUCCESS = 'RULE_SAVE_SUCCESS';
export const RULE_SAVE_FAILURE = 'RULE_SAVE_FAILURE';

export const RULE_DELETE_REQUEST = 'RULE_DELETE_REQUEST';
export const RULE_DELETE_SUCCESS = 'RULE_DELETE_SUCCESS';
export const RULE_DELETE_FAILURE = 'RULE_DELETE_FAILURE';

export const RULE_SELECT     = 'RULE_SELECT';
export const RULE_FORM_RESET = 'RULE_FORM_RESET';

export const FORMULA_VALIDATE_REQUEST = 'FORMULA_VALIDATE_REQUEST';
export const FORMULA_VALIDATE_SUCCESS = 'FORMULA_VALIDATE_SUCCESS';
export const FORMULA_VALIDATE_FAILURE = 'FORMULA_VALIDATE_FAILURE';
export const FORMULA_VALIDATE_RESET   = 'FORMULA_VALIDATE_RESET';

// --- Engine Logs ---
export const ENGINE_LOGS_FETCH_REQUEST = 'ENGINE_LOGS_FETCH_REQUEST';
export const ENGINE_LOGS_FETCH_SUCCESS = 'ENGINE_LOGS_FETCH_SUCCESS';
export const ENGINE_LOGS_FETCH_FAILURE = 'ENGINE_LOGS_FETCH_FAILURE';

// =============================================================================
// Opções de UI
// =============================================================================

export const TECH_OPTIONS = ['2G', '3G', '4G', '5G'];

export const STATUS_OPTIONS = [
	{ value: 'Open',   label: 'Aberto'  },
	{ value: 'Closed', label: 'Fechado' },
];

export const DIRECTION_OPTIONS = [
	{ value: false, label: 'Queda indica problema (Availability, Setup SR, Throughput)' },
	{ value: true,  label: 'Subida indica problema (Drop Rate, Block Rate, PRB Utilization)' },
];

export const DETECTION_METHOD_OPTIONS = [
	{
		value: 'PERCENTILE',
		label: 'Percentil (recomendado)',
		description:
			'Compara o KPI atual com a distribuição histórica desta célula (P95/P5). '
			+ 'Robusto a distribuições não-normais (Drop Rate, Block Rate). '
			+ 'O alarme só dispara quando o KPI ultrapassa em simultâneo o SLA absoluto e o seu próprio percentil.',
	},
	{
		value: 'THRESHOLD',
		label: 'Threshold (SLA fixo)',
		description:
			'Dispara apenas quando o KPI ultrapassa o limiar de SLA absoluto, sem comparação com o histórico. '
			+ 'Usar quando existe um SLA contratual rígido (ex.: Availability < 98.5%).',
	},
	{
		value: 'ZSCORE',
		label: 'Z-Score (estatístico clássico)',
		description:
			'Compara o KPI com a média histórica ± 2.5 desvios-padrão. '
			+ 'Recomendado para Availability (distribuição perto de 100% com desvio pequeno). '
			+ 'Menos robusto que o Percentil para Drop Rates.',
	},
];

export const SEVERITY_OPTIONS = [
	{ value: 1, label: 'Crítica', color: '#d32f2f' },
	{ value: 2, label: 'Alta',    color: '#ed6c02' },
	{ value: 3, label: 'Média',   color: '#0288d1' },
];

export const DURATION_OPTIONS = [
	{ value: 'all',  label: 'Qualquer duração' },
	{ value: 'lt1',  label: '< 1 dia (hoje)' },
	{ value: '1to3', label: '1 a 3 dias' },
	{ value: '4to7', label: '4 a 7 dias' },
	{ value: 'gt7',  label: '> 7 dias (crónicos)' },
];

export const TECH_COLOR = {
	'2G': '#f59e0b',
	'3G': '#3b82f6',
	'4G': '#10b981',
	'5G': '#8b5cf6',
};

// =============================================================================
// Texto de apoio (tooltips) mostrado nos campos do formulário de regras
// =============================================================================

export const TOOLTIPS = {
	detectionMethod:
		'Método estatístico a aplicar.\n\n'
		+ 'Percentil: compara o KPI com os percentis históricos desta célula (P95/P5).\n'
		+ 'Threshold: usa apenas o SLA absoluto.\n'
		+ 'Z-Score: compara com a média e o desvio-padrão.\n\n'
		+ 'Recomendado para Drop Rates: Percentil.\n'
		+ 'Recomendado para Availability: Z-Score.',

	slaThreshold:
		'Limiar absoluto baseado no SLA contratual.\n\n'
		+ '"Subida indica problema": o critério absoluto dispara quando KPI > SLA.\n'
		+ '"Queda indica problema": o critério absoluto dispara quando KPI < SLA.\n\n'
		+ 'No método Percentil, este valor é combinado com o percentil (E).\n'
		+ 'No método Threshold, é a única condição.\n\n'
		+ 'Exemplos: Voice Drop Rate 4G = 0.8 (0.8%) · Voice Setup SR 4G = 99.0 · Availability = 98.5',

	direction:
		'Sentido em que a degradação do KPI ocorre.\n\n'
		+ 'Subida indica problema: para KPIs em que um valor mais alto é pior (Drop Rate, Block Rate, PRB Utilization).\n\n'
		+ 'Queda indica problema: para KPIs em que um valor mais baixo é pior (Availability, Setup SR, Throughput, CQI).',

	minVolumeAbsolute:
		'Piso estatístico mínimo — não é o volume de produção esperado.\n\n'
		+ 'O filtro aplicado pelo motor é sempre o maior entre este valor e 30% do volume médio histórico da célula:\n'
		+ 'MAX(este valor, Volume Médio Histórico × 0.30)\n\n'
		+ 'Exemplos com este valor definido para 20:\n'
		+ '· Célula urbana (volume médio 5000) → filtro efetivo = 1500\n'
		+ '· Célula rural (volume médio 80) → filtro efetivo = 24\n'
		+ '· Célula rural pequena (volume médio 30) → filtro efetivo = 20\n\n'
		+ 'Valores típicos por tecnologia: 2G = 15 · 3G = 20 · 4G = 20 · 5G = 15.',

	useDayOfWeek:
		'Deve a baseline considerar o dia da semana?\n\n'
		+ 'Sim (recomendado para Drop Rate, Throughput, Setup SR): a baseline usa as 12 ocorrências mais recentes do mesmo dia da semana, isolando padrões semanais (ex.: sexta à noite vs. domingo).\n\n'
		+ 'Não (recomendado para Availability): a baseline usa os últimos 28 dias consecutivos. Adequado a KPIs cuja variação não depende do dia da semana (avarias, alarmes de equipamento).',

	severity:
		'Severidade operacional atribuída ao alarme gerado por esta regra.\n\n'
		+ 'Crítica: impacto direto no serviço — Availability, Drop Rates.\n'
		+ 'Alta: impacto na experiência do cliente — Setup SR, Block Rates.\n'
		+ 'Média: indicadores de qualidade — Throughput, CQI.',
};

// =============================================================================
// Perfis pré-configurados — usados no botão "Aplicar perfil pré-definido"
// =============================================================================

export const KPI_PROFILES = [
	{
		key: 'drop_rate_2g',
		label: 'Drop Rate · 2G',
		preset: {
			detectionMethod:   'PERCENTILE',
			slaThreshold:      2.0,
			direction:         true,
			minVolumeAbsolute: 15,
			useDayOfWeek:      true,
			severity:          1,
		},
	},
	{
		key: 'drop_rate_3g',
		label: 'Drop Rate · 3G',
		preset: {
			detectionMethod:   'PERCENTILE',
			slaThreshold:      1.0,
			direction:         true,
			minVolumeAbsolute: 20,
			useDayOfWeek:      true,
			severity:          1,
		},
	},
	{
		key: 'drop_rate_4g',
		label: 'Drop Rate · 4G',
		preset: {
			detectionMethod:   'PERCENTILE',
			slaThreshold:      0.8,
			direction:         true,
			minVolumeAbsolute: 20,
			useDayOfWeek:      true,
			severity:          1,
		},
	},
	{
		key: 'drop_rate_5g',
		label: 'Drop Rate · 5G',
		preset: {
			detectionMethod:   'PERCENTILE',
			slaThreshold:      1.2,
			direction:         true,
			minVolumeAbsolute: 15,
			useDayOfWeek:      true,
			severity:          1,
		},
	},
	{
		key: 'setup_sr_voice',
		label: 'Voice Setup SR',
		preset: {
			detectionMethod:   'PERCENTILE',
			slaThreshold:      99.0,
			direction:         false,
			minVolumeAbsolute: 20,
			useDayOfWeek:      true,
			severity:          2,
		},
	},
	{
		key: 'setup_sr_data',
		label: 'Data Setup SR',
		preset: {
			detectionMethod:   'PERCENTILE',
			slaThreshold:      97.0,
			direction:         false,
			minVolumeAbsolute: 20,
			useDayOfWeek:      true,
			severity:          2,
		},
	},
	{
		key: 'availability',
		label: 'Availability',
		preset: {
			detectionMethod:   'ZSCORE',
			slaThreshold:      98.5,
			direction:         false,
			minVolumeAbsolute: 20,
			useDayOfWeek:      false,
			severity:          1,
		},
	},
];

// ============================================================================
// Valores iniciais para nova regra
// ============================================================================

export const EMPTY_RULE = {
	kpiId:             0,
	kpiName:           '',
	tech:              '4G',
	sourceTable:       '',
	sourceVendorCol:   'VENDOR',
	sourceSiteCol:     'JV_ID',
	sourceCellCol:     'MI_MYCOM_ID',
	sourceDateCol:     'DATE',
	kpiFormula:        '',
	volFormula:        '',
	detectionMethod:   'PERCENTILE',
	slaThreshold:      0,
	direction:         true,
	minVolumeAbsolute: 20,
	useDayOfWeek:      true,
	severity:          2,
	active:            true,
};
